export const aboutInfo = {
  brandName: '爱液视频',
  foundedYear: '2019',
  headquarters: '中国·深圳',
  employees: '500+',
  description: '爱液视频成立于2019年，是一家专注于视频内容聚合与分发的互联网科技公司。我们致力于为用户提供海量、优质、高清的视频内容，打造极致的观影体验。经过多年发展，爱液视频已成为国内领先的视频内容平台之一，累计服务超过5000万用户。',
  mission: '让每个人都能轻松享受高质量的视频内容',
  vision: '成为全球最受欢迎的视频内容平台',
  values: [
    { title: '用户至上', description: '始终以用户需求为核心，持续优化产品体验' },
    { title: '内容为王', description: '坚持引入优质内容，打造丰富多元的内容生态' },
    { title: '技术创新', description: '持续投入技术研发，用科技提升视频服务体验' },
    { title: '诚信正直', description: '坚守商业道德，保护用户隐私与数据安全' },
  ],
  milestones: [
    { year: '2019年', event: '爱液视频App正式上线，推出Android和iOS双平台版本' },
    { year: '2020年', event: '用户突破1000万，获评年度最佳视频应用' },
    { year: '2021年', event: '上线智能推荐系统，内容库突破5万小时' },
    { year: '2022年', event: '用户突破3000万，推出会员服务体系' },
    { year: '2023年', event: '获得国家高新技术企业认证，内容库突破8万小时' },
    { year: '2024年', event: '用户突破5000万，推出AI智能推荐2.0，全面升级播放引擎' },
  ],
  reviews: [
    {
      name: '张先生',
      avatar: 'Z',
      rating: 5,
      content: '用了两年多了，内容真的很丰富，更新也快。会员价格合理，去广告后体验好很多。强烈推荐！',
      date: '2025-12-10',
    },
    {
      name: '李女士',
      avatar: 'L',
      rating: 5,
      content: '离线缓存功能太实用了！每天通勤路上看缓存好的剧，完全不费流量。推荐算法也很准，总能发现好看的。',
      date: '2025-12-08',
    },
    {
      name: '王同学',
      avatar: 'W',
      rating: 4,
      content: '作为学生党，免费版内容已经足够丰富了。画质清晰，播放流畅，是我用过最好的视频App之一。',
      date: '2025-12-05',
    },
    {
      name: '赵女士',
      avatar: 'Z',
      rating: 5,
      content: '全家人都在用，老人看电视剧，孩子看动画片，我和老公看电影。家长控制功能很贴心，给孩子设置了观看时间限制。',
      date: '2025-12-01',
    },
    {
      name: '陈先生',
      avatar: 'C',
      rating: 5,
      content: '播放体验确实一流，即使在高铁上信号不好的时候也能流畅播放。投屏到电视上看大片，效果杠杠的！',
      date: '2025-11-28',
    },
    {
      name: '刘女士',
      avatar: 'L',
      rating: 4,
      content: '综艺更新速度很快，播出当天就能看到。弹幕功能很有意思，看综艺开着弹幕笑点加倍。希望内容能再丰富一些。',
      date: '2025-11-25',
    },
  ],
  contact: {
    email: 'support@aiyeshipin.com',
    phone: '400-888-9999',
    address: '广东省深圳市南山区科技园南路88号',
    workHours: '周一至周五 9:00 - 18:00',
    socialMedia: [
      { name: '微信公众号', icon: 'ri-wechat-line', link: '#' },
      { name: '官方微博', icon: 'ri-weibo-line', link: '#' },
      { name: '抖音官方号', icon: 'ri-tiktok-line', link: '#' },
    ],
  },
};

export const downloadLinks = {
  android: {
    label: 'Android下载',
    icon: 'ri-android-line',
    url: '#android-download',
    version: 'v5.8.2',
    size: '68.5 MB',
  },
  ios: {
    label: 'iOS下载',
    icon: 'ri-apple-line',
    url: '#ios-download',
    version: 'v5.8.2',
    size: '145.2 MB',
  },
};